/* unplugin-vue-components disabled */import script from "./score_rule.vue?vue&type=script&setup=true&lang=js"
export * from "./score_rule.vue?vue&type=script&setup=true&lang=js"

import "./score_rule.vue?vue&type=style&index=0&id=2aa06462&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa06462"]])

export default __exports__